import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from 'src/components/Checkbox';

import { AutomationItem } from '../types';

interface GroupOneTimePurchaseFieldProps {
  automation: AutomationItem;
  index: number;
}

export const GroupOneTimePurchaseField: FC<GroupOneTimePurchaseFieldProps> = ({
  automation,
  index,
}) => {
  const { t } = useTranslation();
  const { setFieldValue } = useFormikContext();

  if (automation.reminderType !== 'group') {
    return null;
  }

  return (
    <Checkbox
      label={t('automations.purchase.oneTimePurchase')}
      checked={Boolean(automation.lifeTime)}
      onChange={(e) => {
        setFieldValue(`automations.${index}.lifeTime`, e.target.checked);
        if (e.target.checked) {
          setFieldValue(`automations.${index}.stripePlan`, null);
          setFieldValue(`automations.${index}.afterTrial`, false);
        }
      }}
    />
  );
};
